import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// DISABLE REACT ERROR OVERLAY COMPLETELY
if (process.env.NODE_ENV === 'development') {
  const disableOverlay = () => {
    // Remove error overlay if it exists
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) overlay.remove();
    
    const overlayDiv = document.querySelector('body > div[style*="position: fixed"]');
    if (overlayDiv && overlayDiv.innerHTML.includes('runtime error')) {
      overlayDiv.remove();
    }
  };
  
  // Run periodically to catch any overlays
  setInterval(disableOverlay, 100);
  
  // Also disable the error handler
  window.__REACT_ERROR_OVERLAY_GLOBAL_HOOK__ = {
    handleRuntimeError: () => {},
    shouldShowOverlay: () => false
  };
}

// Suppress ALL errors globally - prevent red overlay
window.addEventListener('error', (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
  return true;
}, true);

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

// Override console.error to suppress overlay triggers
const originalError = console.error;
console.error = (...args) => {
  // Don't log to console at all for Script errors
  const errorString = args.join(' ');
  if (errorString.includes('Script error') || 
      errorString.includes('ChunkLoadError') ||
      errorString.includes('removeChild')) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
